import React, { Component } from 'react';
import styles from './article-tile-grid.scss';
import { ISalesDesignationView } from './article-tile/article-tile.d';

interface IPromotionTileContainerProps {
    article: ISalesDesignationView;
    html?: string;
    onClick: (tileId: string, pageNo: number) => void;
}

/**
 * Hosts the server rendered promotion tile markup. The markup is written once per (instance, html) pair
 * and the shell is told to initialize the tile only after the node is attached, so there are no fixed delays
 * and no stale initializations of nodes that React has already replaced.
 */
export default class PromotionTileContainer extends Component<IPromotionTileContainerProps> {
    private appliedHtml?: string;
    private initFrame?: number;

    componentDidMount(): void {
        this.applyHtml();
    }

    componentDidUpdate(): void {
        this.applyHtml();
    }

    componentWillUnmount(): void {
        this.cancelInit();
    }

    private applyHtml(): void {
        const node = this.props.article.elementRef?.current;
        const html = this.props.html;

        if (!node || html === undefined || html === this.appliedHtml)
            return;

        this.appliedHtml = html;
        node.innerHTML = html;

        this.cancelInit();
        this.initFrame = window.requestAnimationFrame(() => {
            this.initFrame = undefined;
            if (window.shell && node.isConnected) {
                window.shell.publishTo('ESPP.PromotionTile.Init', { newContext: node });
            }
        });
    }

    private cancelInit(): void {
        if (this.initFrame !== undefined) {
            window.cancelAnimationFrame(this.initFrame);
            this.initFrame = undefined;
        }
    }

    render() {
        const { article, onClick } = this.props;
        return (
            <div className={styles.promo_tile_container}
                id={'PromotionTile_' + article.promotionTileKey}
                data-promotion-tile-index={article.promotionTileIndex}
                data-container-tile-key={article.promotionTileKey}
                onClick={() => onClick(article.tileId, article.pageNo)}
                suppressHydrationWarning={true}
                ref={article.elementRef} />
        );
    }
}
